import { render, staticRenderFns } from "./inscription-list-editable.vue?vue&type=template&id=18753ab4&"
import script from "./inscription-list-editable.vue?vue&type=script&lang=js&"
export * from "./inscription-list-editable.vue?vue&type=script&lang=js&"
import style0 from "./inscription-list-editable.vue?vue&type=style&index=0&id=18753ab4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports